import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./UserRightsManagementPage.scss";
import heroBanner from "../../assets/images/banner-user-rights-management.png";
import Copyright from "../../components/Copyright/Copyright";

const UserRightsManagementPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={heroBanner} alt="User Rights Management" />
          </div>
        </div>
      </section>

      {/* User Rights Management Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>User rights management</h2>
              <p>
                Take full control of your system with our advanced user rights management system.
                Define granular permissions, manage access levels, and ensure security compliance
                across your entire organization.
              </p>

              <div className="feature-methods">


                <div className="feature-method">
                  <div className="method-content">
                    <h3>Granular permissions</h3>
                    <p>
                      Set detailed permissions at the company and module level.
                      Control exactly what each user can do.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Audit trail</h3>
                    <p>
                      Track all user activities with comprehensive
                      audit logs for compliance and security monitoring.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              <div className="features-list">
                <div className="feature-item">
                  <h3>Multi-level security</h3>
                  <p>Implement enterprise-grade security with multiple permission levels.</p>
                </div>

                <div className="feature-item">
                  <h3>Administrative access</h3>
                  <p>Assign administrative access to specific users to manage system settings and access permissions.</p>
                </div>

                <div className="feature-item">
                  <h3>Session-based access</h3>
                  <p>Set limit on the number of sessions a user can have for better security and resource management.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Implementation Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Implementation process</h2>
            <p>Simple steps to get your user rights management system up and running</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Assessment</h3>
                <p>We analyze your current user structure and security requirements to design the optimal rights management system.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Role definition</h3>
                <p>Define specific permissions based on your organizational needs and compliance requirements.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>User assignment</h3>
                <p>Assign users to appropriate roles and configure individual permissions where needed for maximum flexibility.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Testing & training</h3>
                <p>Thoroughly test the system and provide comprehensive training to ensure smooth adoption and proper usage.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to secure your system?</h2>
            <p>
              Implement comprehensive user rights management and take control of your system security.
              Contact us today to discuss your specific requirements.
            </p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default UserRightsManagementPage;
